import type { Address, FirestoreEntity, Summary, WithId } from './entities';
import type { CommentCount } from './comment';

export type Customer = CustomerEntity & WithId;

export interface CustomerEntity extends CommentCount {
  type: CustomerType;
  displayName: string;
  company: {
    displayName: string;
    legalName: string;
  };
  individual: {
    firstName: string;
    lastName: string;
  };
  address: Address;
  avatarPath: string;
}

export type FirestoreCustomer = FirestoreEntity<Customer>;

export type CustomerSummary = Summary;

export type CustomerType = 'company' | 'individual';

export function mapCustomerSummary(customer: FirestoreCustomer) {
  return {
    id: customer.id,
    displayName: customer.data.displayName || 'No Displayname',
  };
}
